<script setup lang="ts"></script>

<template>
  <FontAwesomeIcon
    class="position-absolute text-dark"
    style="top: 55px; left: 20.3%"
    :icon="['fas', 'arrow-down']"
  />
  <FontAwesomeIcon
    class="position-absolute text-dark"
    style="top: 45px; left: 30.2%"
    :icon="['fas', 'arrow-down']"
  />
  <FontAwesomeIcon
    class="position-absolute text-dark"
    style="top: 25px; left: 52%"
    :icon="['fas', 'arrow-down']"
  />
  <FontAwesomeIcon
    class="position-absolute text-dark"
    style="top: 30px; left: 66.4%"
    :icon="['fas', 'arrow-down']"
  />
</template>
